import services from '../services/api';

const api = services.apiV1;
const apiv2 = services.apiv2;

const UserRepository = {
  async verifyPhone(phone) {
    const { data } = await api.get(`users/validate/by-phone?phone=${phone}`);

    return data.status;
  },

  async verifyCpfCnpj(cpfCnpj) {
    const { data } = await api.get(
      `users/validate/by-cpf-cnpj?cpfCnpj=${cpfCnpj}`,
    );
    return data.status;
  },

  async verifyEmail(email) {
    const { data } = await api.get(`users/validate/by-email?email=${email}`);

    return data.status;
  },

  async createUser(body) {
    const { data } = await api.post(`users/`, body);
    return data;
  },

  async restorePasswordByEmail(body) {
    const { data } = await apiv2.post(`users/forgot-password/email`, body);

    return data;
  },

  // Servidor gera o codigo e devolve apenas { challenge }
  async restorePasswordByPhone(body) {
    const { data } = await apiv2.post(`users/forgot-password/phone`, body);

    return data;
  },

  // Confere o codigo digitado e devolve { token } para usar em updatePassword
  async verifyPhoneCode({ challenge, code }) {
    const { data } = await apiv2.post(`users/forgot-password/phone/verify`, {
      challenge,
      code,
    });

    return data;
  },

  // A sessao vem do cookie HttpOnly
  async getUserById() {
    const { data } = await api.get(`users/by-id`);
    return data;
  },

  async updateUser(id, body) {
    const { data } = await api.put(`users/${id}`, body);
    return data;
  },

  // token = token do link de e-mail, enviado em header explicito (nao ha sessao nesse fluxo)
  async updatePassword({ token, password }) {
    try {
      const { data } = await api.put(
        `update-password`,
        { password },
        {
          headers: {
            'x-access-token': token,
          },
        },
      );
      return data;
    } catch (err) {
      throw err;
    }
  },

  async login({ login, password }) {
    try {
      const { data } = await api.post(`users/login`, { login, password });
      return data;
    } catch (err) {
      throw err;
    }
  },
};

export default UserRepository;
